import { defaultSearchStore, searchStore } from 'owa-mail-search-store';
import { lazyClearLocalContentInstrumentationCache, lazyFlushNonRenderedItemsFromCache, } from 'owa-search-service';
/**
 * This function takes care of all the store operations necessary to get to
 * a clean suggestion state after a search "conversation" ends.
 *
 * A "conversation" is defined as a series of keystrokes follow by either:
 *  - A click on a suggestion
 *  - A search query being issued
 *  - Abandonment (search session ends)
 */
export default function endSearchConversation() {
    // Clean up store for next query.
    searchStore.latestQfRequestId = defaultSearchStore.latestQfRequestId;
    searchStore.searchTextForSuggestion = defaultSearchStore.searchTextForSuggestion;
    searchStore.currentSuggestions = defaultSearchStore.currentSuggestions;
    // Flush cache since conversation has ended.
    lazyFlushNonRenderedItemsFromCache.importAndExecute();
    lazyClearLocalContentInstrumentationCache.importAndExecute();
}
//# sourceMappingURL=endSearchConversation.js.map